export default __webpack_public_path__ + "static/media/minesweeper.26cfb1d9.png";